module.exports = __webpack_public_path__ + "static/36fe0bafc412d9400c28862b058555c2e4d575b9fb7e6b32d893067f43e65271-47d0b6b418a28f535387632a68a8ad3b.jpeg";